<template>
  <div>
    <custom-dialog width="466px" v-if="visibleObj.registerDialog" :visible="visibleObj.registerDialog"
      @close="dialogVisible('registerDialog')" @save="confirm">
      <div slot="header">
        <el-form class="patient-warp" ref="registerForm" inline :rules="rules" :model="registerForm">
          <el-form-item prop="patientName" class="mr4">
            <el-select
              ref="patientNameSelect"
              :popper-append-to-body="false"
              popper-class="customSelectStyle"
              class="name-select"
              v-model="registerForm.patientName"
              placeholder="患者姓名"
              filterable
              remote
              reserve-keyword
              :remote-method="getPatientInfoByName"
              :disabled="dialogObj && dialogObj.sourceType == 'change'"
              value-key="patientId"
              @change="selectPatient"
              @visible-change="patientNameVisible">
              <el-option v-for="item in patientList" :key="item.patientId" :value="item" class="display-f">
                <span style="width: 96px; display:inline-block;" class="mr12 text-overflow">{{ item.patientName }}</span>
                <span class="mr24">{{ item.sex == '0' ? '男' : '女' }}</span>
                <span style="width: 72px; display:inline-block" class="mr24">{{ item.age }}岁{{ item.ageMth }}月</span>
                <span style="width: 112px; display:inline-block">{{ item.phone }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="sex" class="mr4">
            <el-select disabled :popper-append-to-body="false" popper-class="customSelectStyle" class="sex-select"
              v-model="registerForm.sex">
              <el-option v-for="item in [{ label: '男', value: '0' }, { label: '女', value: '1' }]" :key="item.value"
                :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item prop="year" class="mr4">
            <el-input disabled ref="year" class="year-input" v-model.number="registerForm.year" @blur="computeBirthday">
            </el-input>
            <div class="append">岁</div>
          </el-form-item>
          <el-form-item prop="month" class="mr4">
            <el-input disabled ref="month" class="year-input" v-model.number="registerForm.month"
              @blur="computeBirthday">
            </el-input>
            <div class="append">月</div>
          </el-form-item>
          <el-form-item prop="phone" class="mr4">
            <el-select
              ref="patientPhoneSelect"
              :popper-append-to-body="false"
              popper-class="customSelectStyle"
              class="phone-select"
              v-model="registerForm.phone"
              placeholder="患者手机号"
              filterable
              remote
              reserve-keyword
              :remote-method="getPatientInfoByPhone"
              :disabled="dialogObj && dialogObj.sourceType == 'change'"
              value-key="patientId"
              @change="selectPatient"
              @visible-change="patientPhoneVisible">
              <el-option v-for="item in patientList" :key="item.patientId" :value="item">
                <span style="width: 96px; display:inline-block" class="mr12">{{ item.patientName }}</span>
                <span class="mr24">{{ item.sex == '0' ? '男' : '女' }}</span>
                <span style="width: 72px; display:inline-block" class="mr24">{{ item.age }}岁{{ item.ageMth }}月</span>
                <span style="width: 112px; display:inline-block">{{ item.phone }}</span>
              </el-option>
            </el-select>
            <div class="close-icon iconfont icon-cha" @click="clearPatient" v-if="registerForm.patientId && dialogObj.sourceType != 'change'"></div>
            <!-- <div class="edit-icon iconfont icon-xiug" @click="editPatient" v-if="registerForm.patientId && dialogObj.sourceType != 'change'"></div> -->
          </el-form-item>
          <div class="add-btn" @click="handleAddPatient" v-if="dialogObj.sourceType != 'change'">
            <span class="iconfont icon-xinzenghuanz icon-1F2329"></span>
          </div>
        </el-form>
      </div>
      <div slot="content" class="registerForm-warp">
        <el-form size="" inline :rules="rules" :model="registerForm" ref="registerForm">
          <div class="content-warp">
            <div class="display-f">
              <el-form-item label="医生" prop="doctorId" class="mr8">
                <custom-select class="select-el-input__inner" :configs="doctorOptionsConfig" :disabled="dialogObj && dialogObj.sourceType == 'change'"
                  :popper-append-to-body="false" filterable v-model="registerForm.doctorId" placeholder="医生姓名"
                  @change="selectDoctor" :options="doctorOptions"></custom-select>
              </el-form-item>
              <el-form-item prop="doctorVisit">
                <custom-select disabled :popper-append-to-body="false" popper-class="customSelectStyle" :disabled="dialogObj && dialogObj.sourceType == 'change'"
                  class="select-el-input__inner" v-model="registerForm.doctorVisit" placeholder="初/复诊"
                  :options="doctorVisitList"></custom-select>
              </el-form-item>
            </div>
            <div class="display-f">
              <el-form-item label="日期" prop="schedulingTime" class="mr8">
                <!-- <el-input class="date-input" v-model="registerForm.date" prefix-icon="el-icon-date"></el-input> -->
                <el-date-picker ref="datePicker" popper-class="customDate" :append-to-body="false"
                  v-model="registerForm.schedulingTime" class="date-input" type="date" value-format="yyyy-MM-dd"
                  placeholder="选择日期" :picker-options="pickerOptions" @change="dateChange">
                </el-date-picker>
              </el-form-item>
              <el-form-item prop="schedulingItemId">
                <custom-select class="select-el-input__inner" :configs="schedulingOptionsConfig"
                  @focus="schedulingItemFocus" v-model="registerForm.schedulingItemId" placeholder="就诊班次"
                  @change="schedulingItemChange" :options="schedulingOptions"></custom-select>
              </el-form-item>
            </div>
            <div class="display-f">
              <el-form-item label="类型" prop="type" class="mr8">
                <custom-select class="select-el-input__inner" v-model="registerForm.type" placeholder="门诊类型"
                  @change="typeChange" :options="typeOptions"></custom-select>
              </el-form-item>
              <el-form-item>
                <custom-select class="select-el-input__inner"
                  :disabled="registerForm.type == '1' || registerForm.type == '3' || registerForm.type == '6' || registerForm.type == '7'"
                  v-model="registerForm.timeQuantumId" placeholder="就诊时间" :configs="timeRangeListConfig"
                  :options="timeRangeList"></custom-select>
              </el-form-item>
            </div>
            <div class="display-f" v-if="dialogObj && dialogObj.sourceType != 'change'">
              <el-form-item label="渠道" prop="channelType" class="mr8">
                <el-radio-group v-model="registerForm.channelType">
                  <el-radio :label="80">春堂</el-radio>
                  <el-radio :label="60">美团</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="display-f pl10">
              <el-form-item label="推荐" prop="sourceId" class="source_warp">
                <custom-select class="select-el-input__inner width100" v-model="registerForm.sourceId" placeholder="请选择"
                  :disabled="isHasRelation" :configs="sourceListConfig" @change="sourceChange"
                  :options="sourceConfigList"></custom-select>
              </el-form-item>
              <el-form-item prop="referrer">
                <custom-select v-if="registerForm.sourceId == 10" class="select-el-input__inner"
                  :configs="doctorReferrerOptionsConfig" :popper-append-to-body="false" filterable
                  v-model="registerForm.referrerDoctorId" remote reserve-keyword :remote-method="getSourceDoctorList"
                  placeholder="选择医生" :options="doctorReferrerOptions" :disabled="isHasRelation"></custom-select>
                <custom-select v-if="registerForm.sourceId == 11" class="select-el-input__inner"
                  :configs="userOptionsConfig" :popper-append-to-body="false" filterable
                  v-model="registerForm.referrerUserId" remote reserve-keyword :remote-method="getSourceUserList"
                  placeholder="选择员工" :options="userOptions" :disabled="isHasRelation"></custom-select>
              </el-form-item>
              <el-form-item prop="referrerPhone" v-if="registerForm.sourceId == 9">
                <el-input  :disabled="isHasRelation"
                v-model.number="registerForm.referrerPhone" maxlength="11" placeholder="推荐人号码"></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="费用" prop="price" class="mr8">
                <el-input class="charge-input" :disabled="registerForm.type == 5 || dialogObj && dialogObj.sourceType == 'change'"
                  v-model="registerForm.price"></el-input>
                <div class="charge-icon">¥</div>
                <div class="text-icon" v-if="!registerForm.revisitDiscount && isShowAdd">加号</div>
                <div class="text-icon" v-if="registerForm.revisitDiscount">复诊</div>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </custom-dialog>
    <addPatient
      v-if="visiblePatientObj.addPatientDialog"
      :visibleObj="visiblePatientObj"
      :patientInfo="registerForm"
      :title='patientDialogTitle'
      :addPatientType="addPatientType"
      :patientTemporaryMap="patientTemporaryMap"
      @addPatientComfirm="addPatientComfirm"
      @close="close">
    </addPatient>
  </div>
</template>


<script>
import addPatient from '@/components/addPatient'
import CustomDialog from '@/components/customDialog/CustomDialog'
import { patientInfom } from "@/api/patient"; // 病人列表请求
import { doctorList, doctorInfo, getRevisitRegisterPrice } from "@/api/doctor"; // 医生列表请求
import { userList, userInfo } from "@/api/user"; // 医生列表请求
import { isNull, isEmptyArray, debounce } from '@/utils/validateBase'
import { getSchedulingTime, getDoctorVisit, doctorSchedulingList, changeRegister } from '@/api/register'
import { Utils } from '@/utils/utils'
import { scheduleInfo, getTimeQuantumList } from "@/api/schedule"; // 排班请求
import { doctorVisitList } from '@/utils/const'
import { visibleObj } from '@/components/js/dialog'
import CustomSelect from '@/components/CustomSelect'
import { doctorDTO, CommonDTO } from '@/DTO/index'
import { getRelation } from '@/api/registration'
// import { validatePhone } from "@/utils/regexp" // 自定义验证
export default {
  // 定义引入的组件
  components: { CustomDialog, addPatient, CustomSelect },
  props: {
    visibleObj: {
      type: Object,
      default: {}
    },
    dialogObj: {
      type: Object,
      default: {}
    },
  },
  data() {
    var validatePhone = (rule, value, callback) => {
      let expPhone = new RegExp(/^1[3456789]\d{9}$/); // 验证手机号码
      if (value != null && value != "") {
        if (expPhone.test(value) == false) {
            return callback(new Error("请输入正确的手机号！"));
        }
        return callback();
      }
      return callback();
    }
    return {
      visiblePatientObj: visibleObj,
      pickerOptions: {
        cellClassName: (date) => {
          let _currentData = this.getTime(date)
          let _dataObj = {}
          this.schedulingItemList.forEach(item => {
            let time = this.$moment(item.schedulingTime).startOf('day').valueOf()
            _dataObj[time] = item.surNum
          })
          if (_dataObj[_currentData] > 0 && !Utils.lt(this.$moment(date).startOf('day').valueOf(), this.$moment().startOf('day').valueOf())) {
            return `cell-num-data-${_dataObj[_currentData]}`
          }
        },
        disabledDate: (date) => {
          if (Utils.lt(this.$moment(date).startOf('day').valueOf(), this.$moment().startOf('day').valueOf())) {
            return true;
          } else {
            return false;
          }
        }
      },
      doctorVisitList: doctorVisitList,//初诊复诊列表
      rules: {
        price: [
          { required: true, message: '挂号费用不能为空', trigger: 'blur' }
        ],
        doctorId: [
          { required: true, message: '医生姓名不能为空', trigger: 'change' }
        ],
        schedulingTime: [
          { required: true, message: '就诊日期不能为空', trigger: 'change' }
        ],
        schedulingItemId: [
          { required: true, message: '就诊班次不能为空', trigger: 'change' }
        ],
        type: [
          { required: true, message: '门诊类型不能为空', trigger: 'change' }
        ],
        channelType: [
          { required: true, message: '渠道不能为空', trigger: 'change' }
        ],
        referrerPhone:[
          {validator: validatePhone, trigger: 'blur'}
        ]
      },//验证规则
      patientList: [],//患者列表
      doctorOptions: [],//医生列表
      schedulingItemList: [],//医生这个月的全部排班列表
      registerForm: {
        deptId: this.$session.get('deptId'),
        patientName: '',//患者姓名
        sex: '0',//患者性别
        doctorName: '',//医生姓名
        month: '',//月份
        year: "",//岁
        schedulingTime: '',//日期
        type: '',//门诊类型
        channelType: 80,//渠道
        timeQuantumId: '',//就诊时间
        schedulingItemId: '',//班次id
        doctorVisit: '0',//初诊、复诊
        price: '',
        referrer: '',
        referrerDoctorId: '',
        referrerUserId: '',
        referrerPhone: '',
        sourceId: '',
        revisitDiscount: false
      },
      typeOptions: [],//门诊类型
      schedulingOptions: [], // 医生排班选项
      timeRangeList: [],//就诊时间段
      doctorOptionsConfig: {
        value: 'doctorId',
        label: 'doctorName'
      },//医生下拉配置
      schedulingOptionsConfig: {
        value: 'schedulingItemId',
        label: 'timeName'
      },//就诊班次下拉配置
      timeRangeListConfig: {
        value: 'id',
        label: 'name',
        text: 'label'
      },//就诊时间下拉配置
      sourceListConfig: {
        value: 'id',
        label: 'sourceName',
      },//就诊时间下拉配置
      patientDialogTitle: '新增患者',//新增患者弹框
      addPatientType: '',//患者弹框type
      sourceConfigList: [],
      doctorReferrerOptions: [],
      isHasRelation: false,//是否有关联关系
      doctorReferrerOptionsConfig: {
        value: 'doctorId',
        label: 'doctorName'
      },//医生下拉配置
      userOptionsConfig: {
        value: 'userId',
        label: 'nickName'
      },//医生下拉配置
      userOptions: [],
      patientTemporaryMap: {
        name: '',
        phone: ''
      }
    }
  },
  //变量监听
  watch: {},
  computed: {
    isShowAdd() {
      if (this.registerForm.type == 1 || this.registerForm.type == 3 || this.registerForm.type == 6 || this.registerForm.type == 7) {
        return true;
      } else {
        return false;
      }
    },
  },
  // 页面初始化
  async created() {
    this.$nextTick(() => {
      this.$refs.patientNameSelect.focus()
    })
    let { doctorId, doctorName, surNum, currenDate,sourceType,patientId,patientName, phone , age,ageMth,sex,price} = this.dialogObj
    this.registerForm.doctorId = doctorId
    this.registerForm.doctorName = doctorName
    this.registerForm.schedulingTime = currenDate;
    this.getDoctorList();
    this.getSchedulingTime();
    if (!isNull(doctorId)) { this.getDoctorSchedulingListByMonth(doctorId); }
    let sourceConfigList =  await CommonDTO.getSourceConfig()
    this.sourceConfigList = sourceConfigList && sourceConfigList.filter(item => item.showType == '2')
    if (sourceType == 'change') {
      this.doctorOptions.push({ doctorName, doctorId });
      this.registerForm.patientId = patientId
      this.registerForm.patientName = patientName
      this.registerForm.phone = phone
      this.registerForm.year = age
      this.registerForm.month = ageMth
      this.registerForm.sex = sex
      this.registerForm.price = price

    }
  },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() { },
  // 页面方法
  methods: {
    getTime(date) {
      // 获取日期的时间戳
      return this.$moment(date).startOf('day').valueOf()
    },
    // 计算生日
    computeBirthday() {
      this.registerForm.birthday = this.$computeBirthday(this.registerForm.year, this.registerForm.month);
    },
    /**
     * 确认额
     */
    confirm() {
      if (isNull(this.registerForm.patientId) || isNull(this.registerForm.month) || isNull(this.registerForm.year) || isNull(this.registerForm.phone)) return this.$message.error('请填写患者信息或创建新患者')
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          if(this.dialogObj.sourceType == 'change'){
            this.$confirm(`是否确认改签至${this.$moment(this.registerForm.schedulingTime).format('MM月DD日')} ${this.registerForm.timeQuantumName}`, '确认', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              let params = {
                registeredId: this.dialogObj.registeredId,
                targetTimeQuantumId: this.registerForm.timeQuantumId,
                targetSchedulingItemId: this.registerForm.schedulingItemId,
                targetType: this.registerForm.type,
              }
              changeRegister(params).then(res => {
                if(res.code == 200){
                  this.$message({
                    type: 'success',
                    message: '改签成功!'
                  });
                  this.$emit('refresh')
                }
              })
            }).catch(() => {});
          }else{
            this.registerForm.isHasRelation = this.isHasRelation
            this.$emit('updateData', this.registerForm)
          }
        }
      });
    },
    /**
     * 关闭
     */
    dialogVisible(name) {
      this.$emit("close", name);
    },
    /**
     * 新增患者
     */
    handleAddPatient() {
      // this.$emit('addPatient')
      this.addPatientType = 'add'
      this.visibleObj.addPatientDialog = true;
    },
    // 根据姓名获取患者列表
    getPatientInfoByName: debounce(async function (name) {
      let { code, data } = await patientInfom({ name })
      this.patientList = [];
      if (code == 200) {
        data.forEach(item => { this.$computeAge(item.birthday, item) })
        this.patientList = data;
      }
    }, 300),
    // 根据姓名获取患者列表
    getPatientInfoByPhone: debounce(async function (phone) {
      let { code, data } = await patientInfom({ phone })
      this.patientList = [];
      if (code == 200) {
        data.forEach(item => { this.$computeAge(item.birthday, item) })
        this.patientList = data;
      }
    }, 300),
    /**
     * 选择患者
     */
    selectPatient(item) {
      let { patientId, patientName, phone, age, ageMth, sex, birthday,idCard,realIdCard } = item
      this.registerForm = {
        ...this.registerForm,
        patientId, patientName, phone, year: age, month: ageMth, sex, birthday,idCard,realIdCard
      }
      this.patientList = []
      this.getDoctorVisit();
      this.getRelation()
      this.getRevisitRegisterPrice()
    },
    patientNameVisible (visible) {
      if (!visible) {
        if (['', null, undefined].includes(this.registerForm.patientId)) {
          const input = this.$refs.patientNameSelect.$el.querySelector('.el-input__inner')
          if (!['', null, undefined].includes(input.value)) {
            this.patientTemporaryMap.name = input.value
          }
        } else {
          this.patientTemporaryMap.name = ''
          this.patientTemporaryMap.phone = ''
        }
      }
    },
    patientPhoneVisible (visible) {
      if (!visible) {
        if (['', null, undefined].includes(this.registerForm.patientId)) {
          const input = this.$refs.patientPhoneSelect.$el.querySelector('.el-input__inner')
          if (!['', null, undefined].includes(input.value)) {
            this.patientTemporaryMap.phone = input.value
          }
        } else {
          this.patientTemporaryMap.name = ''
          this.patientTemporaryMap.phone = ''
        }
      }
    },
    // 请求排班医生列表
    getDoctorList() {
      if (isNull(this.registerForm.schedulingTime)) return
      return new Promise(async (resolve, reject) => {
        this.doctorOptions = []
        let { data, code } = await doctorDTO.getDoctorSchedulingList({ deptId: this.deptId, schedulingTime: this.registerForm.schedulingTime });
        if (code == 200) {
          if (isEmptyArray(data)) {
            this.registerForm.doctorId = ''
            this.doctorOptions = []
            this.schedulingOptions = []
            this.typeOptions = []
            this.registerForm.type = ''
            this.registerForm.schedulingItemId = ''
            this.registerForm.timeQuantumId = ''
            this.registerForm.timeQuantumName = ''
            this.registerForm.price = ''
          } else {
            data.forEach(item => {
              this.doctorOptions.push({ doctorName: item.doctorName, doctorId: item.doctorId });
            });
          }
          resolve()
        }
      })
    },
    /**
     * 选择医生
     */
    selectDoctor(id) {
      let index = this.doctorOptions.findIndex(item => { return item.doctorId == id })
      this.registerForm = { ...this.registerForm, ...this.doctorOptions[index] }
      this.getSchedulingTime();
      this.getDoctorVisit();
      this.getDoctorSchedulingListByMonth(id);
      this.getRelation()
    },
    /**
     * 查询医生班次
     */
    async getSchedulingTime() {
      if (isNull(this.registerForm.doctorId) || isNull(this.registerForm.schedulingTime)) return;
      this.schedulingOptions = [];
      let { code, data } = await getSchedulingTime({ doctorId: this.registerForm.doctorId, schedulingTime: this.registerForm.schedulingTime })
      if (code == 200 && !isEmptyArray(data)) {
        data.forEach(item => {
          this.schedulingOptions.push({
            timeName: item.timeName,
            timeId: item.timeId,
            schedulingItemId: item.schedulingItemId,
            clinicName: item.clinicName,
            typeOptions: this.handleTypeOption(item)
          })
        })
        this.registerForm.schedulingItemId = this.schedulingOptions[0].schedulingItemId
        this.registerForm.timeName = this.schedulingOptions[0].timeName
        this.registerForm.timeId = this.schedulingOptions[0].timeId
        this.registerForm.clinicName = this.schedulingOptions[0].clinicName
        this.typeOptions = this.schedulingOptions[0].typeOptions;
        this.registerForm.type = this.schedulingOptions[0].typeOptions[0].value
        if(this.dialogObj.sourceType != 'change'){
          this.registerForm.price = this.schedulingOptions[0].typeOptions[0].price
        }
        this.getTimeQuantumList(this.registerForm.schedulingItemId, this.registerForm.type)
        this.getRevisitRegisterPrice()
      } else {
        this.registerForm.type = ''
        this.registerForm.timeId = ''
        this.registerForm.schedulingItemId = ''
        this.registerForm.timeQuantumId = ''
        this.typeOptions = []
        this.schedulingOptions = []
        this.timeRangeList = []


      }
    },
    /**
     * 处理门诊类型数据
     * isPhysio=1有理疗类型 isContributing=1有特约 isFree != 0有义诊 isFree !=2 有普通
     * 0日常 1日常加号 2特约 3特约加号 4理疗 5义诊 6理疗加号 7义诊加号
     */
    handleTypeOption(item) {
      let typeOptions = []
      if (item.isCommon === 1) {
        if (Utils.gt(item.surComNum, 0)) {
          typeOptions.push({ label:item.isIncrease ? '普通门诊加号' : '普通门诊', value: 0, price: item.registrationCommonPrice })
        } else if(Utils.eq(item.surComNum, 0) && Utils.eq(item.surCtrNum, 0) && Utils.eq(item.surPhyNum, 0) && Utils.eq(item.surFreNum, 0)  && Utils.eq(item.surTraNum, 0) && !item.isIncrease) {
          typeOptions.push({ label: '普通门诊加号', value: 1, price: item.registrationCommonIncreasePrice })
        }
      }
      if (item.isContributing == '1') {
        if (Utils.gt(item.surCtrNum, 0)) {
          typeOptions.push({ label:item.isIncrease ? '特约门诊加号' : '特约门诊', value: 2, price: item.registrationContributingPrice })
        } else if(Utils.eq(item.surComNum, 0) && Utils.eq(item.surCtrNum, 0) && Utils.eq(item.surPhyNum, 0) && Utils.eq(item.surFreNum, 0)  && Utils.eq(item.surTraNum, 0) && !item.isIncrease) {
          typeOptions.push({ label: '特约门诊加号', value: 3, price: item.registrationContributingIncreasePrice })
        }
      }
      if (item.isPhysio == '1') {
        if (Utils.gt(item.surPhyNum, 0)) {
          typeOptions.push({ label: item.isIncrease ? '理疗门诊加号' : '理疗门诊', value: 4, price: item.registrationPhysioPrice })
        } else if(Utils.eq(item.surComNum, 0) && Utils.eq(item.surCtrNum, 0) && Utils.eq(item.surPhyNum, 0) && Utils.eq(item.surFreNum, 0)  && Utils.eq(item.surTraNum, 0) && !item.isIncrease) {
          typeOptions.push({ label: '理疗门诊加号', value: 6, price: item.registrationCtbPhysioPrice })
        }
      }
      if (item.isFree != '0') {
        if (Utils.gt(item.surFreNum, 0)) {
          typeOptions.push({ label: '义诊', value: 5, price: 0 })
        } else if(Utils.eq(item.surComNum, 0) && Utils.eq(item.surCtrNum, 0) && Utils.eq(item.surPhyNum, 0) && Utils.eq(item.surFreNum, 0)  && Utils.eq(item.surTraNum, 0) && !item.isIncrease) {
          typeOptions.push({ label: '义诊加号', value: 7, price: 0 })
        }
      }
      if(item.isTransfer == '1'){
        if (Utils.gt(item.surTraNum, 0)) {
          typeOptions.push({ label: '转方', value: 10, price: item.registrationTransferPrice })
        }else if(Utils.eq(item.surComNum, 0) && Utils.eq(item.surCtrNum, 0) && Utils.eq(item.surPhyNum, 0) && Utils.eq(item.surFreNum, 0)  && Utils.eq(item.surTraNum, 0) && !item.isIncrease){
          typeOptions.push({ label: '转方加号', value: 11, price: item.registrationTransferIncreasePrice })
        } 
      }

      return typeOptions;
    },
    /**
     * 班次改变
     */
    schedulingItemChange(id) {
      if (isNull(this.registerForm.doctorId) || isNull(this.registerForm.schedulingTime)) return this.$message.error('请先选择医生和日期')
      let obj = this.schedulingOptions.find(item => { return item.schedulingItemId == id })
      this.typeOptions = obj.typeOptions
      this.registerForm.schedulingItemId = id;
      this.registerForm.type = obj.typeOptions[0].value
      if(this.dialogObj.sourceType != 'change'){
        this.registerForm.price = obj.typeOptions[0].price
      }
      this.registerForm.timeId = obj.timeId
      this.registerForm.timeName = obj.timeName
      this.getTimeQuantumList(this.registerForm.schedulingItemId, this.registerForm.type)
      this.getRevisitRegisterPrice()
    },
    /**
     * 类型改变
     */
    typeChange(val) {
      let index = this.typeOptions.findIndex(item => { return item.value == val })
      this.registerForm.type = val
      if(this.dialogObj.sourceType != 'change'){
        this.registerForm.price = this.typeOptions[index].price;
      }
      this.getTimeQuantumList(this.registerForm.schedulingItemId, this.registerForm.type)
      this.getRevisitRegisterPrice()
    },

    /**
     * 就诊班次输入框聚焦
     */
    schedulingItemFocus() {
      if (isNull(this.registerForm.doctorId) || isNull(this.registerForm.schedulingTime)) this.$message.error('请先选择医生和日期')

    },
    /**
     * 获取排班下时间段
     * id 排班id
     * type 门诊类型
    */
    getTimeQuantumList(id, type) {
      let param = {
        schedulingItemId: id
      }
      if (!isNull(type)) param.schedulingType = type + ''
      getTimeQuantumList(param).then(res => {
        let { code, data } = res
        if (code == 200) {
          if (data.length > 0) {
            let index = data.findIndex(item => { return item.surNumber > 0 })
            this.registerForm.timeQuantumId = data[index].id
            this.registerForm.timeQuantumName = data[index].name
            // this.timeRangeList = data
            // 处理时间段显示数据
            data.forEach(item => {
              item.label = `${item.name}(${item.surNumber})`
              item.disabled = !Utils.gt(item.surNumber, 0)
            })
            this.timeRangeList = data
          } else {
            this.registerForm.timeQuantumId = ''
            this.registerForm.timeQuantumName = ''
          }
        }
      })
    },
    // 获取复诊价格
    async getRevisitRegisterPrice() {
      if (isNull(this.registerForm.doctorId) || isNull(this.registerForm.patientId) || isNull(this.registerForm.schedulingItemId) || isNull(this.registerForm.type)) return;
      let { code, data } = await getRevisitRegisterPrice({
        deptId: this.$session.get('deptId'),
        doctorId: this.registerForm.doctorId,
        patientId: this.registerForm.patientId,
        schedulingItemId: this.registerForm.schedulingItemId,
        registerType: String(this.registerForm.type)
      })
      if (code == 200) {
        this.registerForm.revisitDiscount = data.revisitDiscount
        this.registerForm.price = data.finalPrice
      }
    },
    /**
    * 选择就诊时间
    * id 就诊时间id
    */
    timeQuantumChange(id) {
      let obj = this.timeRangeList.find(item => {
        return item.id == id
      })
      this.registerForm.timeQuantumId = id
      this.registerForm.timeQuantumName = obj.name
    },
    /**
     * 查询初诊复诊
     */
    async getDoctorVisit() {
      let { doctorId, patientId } = this.registerForm
      if (isNull(doctorId) || isNull(patientId)) return;
      let { code, data } = await getDoctorVisit({ doctorId, doctorId, patientId, patientId, orderId: '' })
      if (code == 200) {
        this.registerForm.doctorVisit = data;
      }

    },
    /**
    * 新增患者确认
    */
    addPatientComfirm(data) {
      let { patientId, patientName, phone, age, ageMth, sex, birthday, sourceId, referrer,addPatientType } = data
      this.registerForm = {
        ...this.registerForm,
        patientId, patientName, phone, year: age, month: ageMth, sex, birthday
      }
      if (addPatientType == 'add') {
        this.registerForm.sourceId = sourceId
        this.isHasRelation = false
        if (!isNull(sourceId) && sourceId == 9) {
          this.registerForm.referrerPhone = referrer
        }
        if (!isNull(sourceId) && sourceId == 10) {
          this.registerForm.referrerDoctorId = referrer
          this.getDoctorInfo(data.referrer)
        }
        if (!isNull(sourceId) && sourceId == 11) {
          this.registerForm.referrerUserId = referrer
          this.getUserInfo(data.referrer)
        }
      }
      this.patientTemporaryMap.name = ''
      this.patientTemporaryMap.phone = ''
      this.visiblePatientObj.addPatientDialog = false;
    },
    /**
     * 关闭新增患者弹框
     */
    close() {
      this.visiblePatientObj.addPatientDialog = false;
    },
    /**
    * 获取某个医生这个月的排班列表
    * id 医生id
    */
    async getDoctorSchedulingListByMonth(id) {
      let obj = {
        doctorId: id,
        deptId: this.$session.get('deptId'),
        startTime: this.$moment(this.dialogObj.schedulingTime).startOf('month').format('YYYY-MM-DD'),
        stopTime: this.$moment(this.dialogObj.schedulingTime).endOf('month').format('YYYY-MM-DD'),
      }
      let { code, rows } = await doctorSchedulingList(obj);
      if (code == 200 && !isEmptyArray(rows)) {
        this.schedulingItemList = rows;
      }
    },
    /**
     * 清空患者
     */
    clearPatient() {
      this.registerForm.birthday = ''
      this.registerForm.month = ''
      this.registerForm.patientId = ''
      this.registerForm.patientName = ''
      this.registerForm.phone = ''
      this.registerForm.sex = ''
      this.registerForm.year = ''
      this.registerForm.doctorVisit = '0'
      this.registerForm.revisitDiscount = false
      this.patientList = []

      const scheduling = this.schedulingOptions.find(item => { return item.schedulingItemId == this.registerForm.schedulingItemId })
      if (scheduling) {
        const typeInfo = scheduling.typeOptions.find(item => { return item.value == this.registerForm.type })
        if (typeInfo) {
          this.registerForm.price = typeInfo.price
        }
      }
    },
    /**
     * 修改患者
     */
    editPatient() {
      this.patientDialogTitle = '修改患者'
      this.addPatientType = 'edit'
      this.visibleObj.addPatientDialog = true;
    },
    /**
     * 切换日期
     */
    async dateChange() {
      await this.getDoctorList();
      let index = this.doctorOptions.findIndex(item => { return item.doctorId == this.registerForm.doctorId })
      if (Utils.gt(index, -1)) {
        this.getSchedulingTime()
      } else {
        this.registerForm.doctorId = ''
        this.schedulingOptions = []
        this.typeOptions = []
        this.registerForm.type = ''
        this.registerForm.schedulingItemId = ''
        this.registerForm.timeQuantumId = ''
        this.registerForm.timeQuantumName = ''
        this.registerForm.price = ''
      }
    },
    //查询关联关系
    async getRelation() {
      if (isNull(this.registerForm.patientId) || isNull(this.registerForm.doctorId)) {
        return
      }
      let { code, data } = await getRelation({ patientId: this.registerForm.patientId, doctorId: this.registerForm.doctorId })
      if (code == 200) {
        if (isNull(data)) {
          this.isHasRelation = false
          this.registerForm.referrer = ''
          this.registerForm.referrerDoctorId = ''
          this.registerForm.referrerUserId = ''
          this.registerForm.referrerPhone = ''
          this.registerForm.sourceId = ''
        } else {
          this.isHasRelation = true
          this.registerForm.sourceId = data.sourceId
          this.registerForm.referrer = data.referrer
          if (data.sourceId == 9) {
            this.registerForm.referrerPhone = data.referrer
          }
          if (data.sourceId == 10) {
            this.registerForm.referrerDoctorId = data.referrer && Number(data.referrer)
            this.getDoctorInfo(data.referrer)
          }
          if (data.sourceId == 11) {
            this.registerForm.referrerUserId = data.referrer && Number(data.referrer)
            this.getUserInfo(data.referrer)
          }
        }

      }

    },
    async getSourceDoctorList(value) {
      let params = {
        pageNum: 1,
        pageSize: 100,
        status: 0,
        deptId: 0,
        doctorName: value
      }
      let { code, rows } = await doctorList(params)
      if (code == 200) {
        this.doctorReferrerOptions = rows
      }
    },
    async getSourceUserList(value) {
      let params = {
        pageNum: 1,
        pageSize: 100,
        nickName: value,
        deptId:'0'
      }
      let { code, rows } = await userList(params)
      if (code == 200) {
        this.userOptions = rows
      }
    },
    sourceChange() {
      this.doctorReferrerOptions = []
      this.registerForm.referrer = ''
      this.registerForm.referrerDoctorId = ''
      this.registerForm.referrerUserId = ''
      this.registerForm.referrerPhone = ''
    },
    //获取医生详情
    async getDoctorInfo(id) {
      if (isNull(id)) return
      let { code, data } = await doctorInfo(id)
      if (code == 200) {
        this.doctorReferrerOptions.push({
          doctorId: data.doctorId,
          doctorName: data.doctorName
        })
      }
    },
    async getUserInfo(id) {
      if (isNull(id)) return
      let { code, data } = await userInfo(id)
      if (code == 200 && !isNull(data.data)) {
        this.userOptions.push({
          userId: data.data.userId,
          nickName: data.data.nickName
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped src="./index.scss"></style>